module.exports = __webpack_public_path__ + "img/e-sign.96c6c400.png";